import React, { forwardRef } from 'react';

import Icon from '@ant-design/icons';
import { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';

import { StarIcon } from '@assets/icons';

import { StyledCustomIcon } from './styled';
import type { IconProps, CustomIconColor } from './types';

export type { IconProps, CustomIconColor };

export type SeturIcon =
  | React.ComponentType<
      | React.PropsWithChildren<CustomIconComponentProps>
      | React.SVGProps<SVGSVGElement>
    >
  | undefined;

export type CustomIconProps = IconProps & {
  icon: SeturIcon;
  className?: string;
  href?: string;
  onClick?: () => void;
  onMouseUp?: (e: React.MouseEvent) => void;
  style?: React.CSSProperties;
};

const CustomIcon = forwardRef(
  (
    {
      icon,
      fontSize = 16,
      fill,
      paletteColor,
      isOpen,
      width,
      height,
      clickable,
      ...rest
    }: React.PropsWithChildren<CustomIconProps>,
    ref
  ) => {
    const colorProps: CustomIconColor = fill ? { fill } : { paletteColor };
    const props = StarIcon === icon ? {} : colorProps;
    return (
      <StyledCustomIcon
        ref={ref as any}
        fontSize={fontSize}
        isOpen={isOpen}
        width={width}
        height={height}
        clickable={clickable}
        {...props}
        {...rest}
        data-role='custom-icon'
      >
        <Icon component={icon} />
      </StyledCustomIcon>
    );
  }
);
export default CustomIcon;
